  Drupal.behaviors.js_scroll = {
    attach: function (context) {
      $('body').once('js_scroll', function () {
        $('.table-content').mCustomScrollbar({
          scrollButtons: {enable: false}
        });
      });
    }
  };
